export enum PaymentMethodsEvents {
  VALIDATION = 'VALIDATION',
  EXPAND = 'EXPAND',
  COLLAPSE = 'COLLAPSE',
  PAYMENT_START = 'PAYMENT_START',
}
